import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { FileGroup, SelectFieldStatus } from "../../../components/Form/FormComponents";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import {
	ApprenticeInformation,
	AttachmentsGroup,
	FundsInformFields,
	Guarantor_1,
	Guarantor_2,
	InvestorInformation,
	// NegotiatorsGroup,
} from "../partials/FormFields";
// import RequestStatusForm from "../../../components/common/RequestStatusForm";
import ActionSideBar from "../partials/ActionSideBar";
import AdminReqStatusForm from "./AdminReqStatusForm";
import AdminApprovalStatus from "../../lease/sections/AdminApprovalStatus";
import { fetchInvestorAssetObject } from "../utils";
import { useDispatch, useSelector } from "react-redux";
import { Backdrop } from "@mui/material";
import FundFinanceRequest from "./FundFinanceRequest";
import { onToggleFundFinanceReqModal } from "../ApprenticeshipSlice";
import { ApprenticeSponsoredRequestStatus } from "../../../components/common/SponsoredRequestStatus";

const SubmittedForm = ({ AFdata }) => {
	const dispatch = useDispatch();
	const { toggleFundFinanceReqModal } = useSelector((state) => state.apprenticeship);

	const [fundRequestTab, setFundRequestTab] = useState(1);

	const [formData, setFormData] = useState(AFdata);
	const [investorData, setInvestorData] = useState(null);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	const adminComments = [
		{
			admin: "Basic Admin (R&C Dept)",
			status: formData?.basicAdminApproval?.status,
			comment: formData?.basicAdminApproval?.comment,
		},
		{
			admin: "1st Line Admin (R&C Dept",
			status: formData?.firstLineApproval?.status,
			comment: formData?.firstLineApproval?.comment,
		},
		{
			admin: "2nd Line Admin (R&C Dept)",
			status: formData?.secondLineApproval?.status,
			comment: formData?.secondLineApproval?.comment,
		},
		{
			admin: "Final Line Admin (R&C Dept)",
			status: formData?.finalApproval?.status,
			comment: formData?.finalApproval?.comment,
		},
		{
			admin: "Admin (Finance Dept)",
			status: formData?.financeApproval?.status,
			comment: formData?.financeApproval?.comment,
		},
		// {
		// 	admin: "1st Line Admin (Finance Dept)",
		// 	status: formData?.approvalStatus,
		// 	comment: "N/A",
		// },
	];

	const fetchInfo = async (query) => {
		const res = await fetchInvestorAssetObject(query);
		setInvestorData(res?.result);
	};

	const onBeginFundRequest = () => {
		dispatch(onToggleFundFinanceReqModal(true));
		setFundRequestTab(1);
	};

	useEffect(() => {
		if (AFdata?.investorFinanceInfo) {
			fetchInfo(AFdata?.investorFinanceInfo?.financeId);
		}
	}, [AFdata]);

	return (
		<>
			<Backdrop open={toggleFundFinanceReqModal} sx={{ zIndex: 13 }}>
				<FundFinanceRequest
					fundRequestTab={fundRequestTab}
					setFundRequestTab={setFundRequestTab}
					requestData={AFdata}
				/>
			</Backdrop>

			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar AFdata={formData} />

				<div className='RightSection w-full'>
					<FormAccordion title='Funds Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<FundsInformFields
								formData={formData}
								// isEditable={isEditable}
								handleInputChange={handleInputChange}
							/>
						</div>
					</FormAccordion>

					<FormAccordion title='Proof of purchase'>
						<div className='form-group'>
							<FileGroup value={formData?.proofOfPurchaseDoc?.url} />
						</div>
					</FormAccordion>

					<FormAccordion title='Attachments'>
						<AttachmentsGroup formData={formData} />
					</FormAccordion>

					<FormAccordion title='Apprentice’s Information'>
						<ApprenticeInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Investor’s Information'>
						<InvestorInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Auto debit'>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<SelectFieldStatus
									name='autoDebit'
									value={formData?.autoDebit ? "Enabled" : "Disabled"}
									type={formData?.autoDebit ? "success" : "error"}
								/>
							</div>
						</div>
					</FormAccordion>

					<FormAccordion title='Insurance'>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<SelectFieldStatus
									name='insurance'
									value={formData?.insurance ? "Enabled" : "Disabled"}
									type={formData?.insurance ? "success" : "error"}
								/>
							</div>
						</div>
					</FormAccordion>

					<FormAccordion title='Guarantor 1'>
						<Guarantor_1 formData={formData} />
					</FormAccordion>

					<FormAccordion title='Guarantor 2'>
						<Guarantor_2 formData={formData} />
					</FormAccordion>

					<FormAccordion title='Commitment fee'>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<SelectFieldStatus
									name='commitmentFee'
									// handleChange={handleInputChange}
									// isEditable={isEditable}
									value={"₦" + formData?.commitmentFee}
									type={"success"}
								/>
							</div>
						</div>
					</FormAccordion>

					{/* <FormAccordion title='Negotiators' open={true}>
						<NegotiatorsGroup formData={formData} />
					</FormAccordion> */}
					{formData?.type?.toLowerCase().includes("quick") && (
						<FormAccordion title='Approval Status' open={false}>
							<AdminApprovalStatus adminLevels={adminComments} />
						</FormAccordion>
					)}

					{formData?.type === "quick" && (
						<FormAccordion title='Request Status' open={true}>
							<AdminReqStatusForm
								formData={formData}
								handleInputChange={handleInputChange}
								adminComments={adminComments}
								investorData={investorData}
								onBeginFundRequest={onBeginFundRequest}
							/>
						</FormAccordion>
					)}

					{formData?.type === "sponsored" && (
						<FormAccordion title='Request Status' open={true}>
							<ApprenticeSponsoredRequestStatus formData={AFdata} />
						</FormAccordion>
					)}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
SubmittedForm.propTypes = {
	AFdata: PropTypes.object,
	setAFdata: PropTypes.func,
	updateCurrentObject: PropTypes.func,
};

export default SubmittedForm;
